<template>
  <v-data-table-server
    v-model:options="options"
    dense
    :headers="headers"
    :loading="loading"
    :items="mappedItems"
    :items-length="totalItems"
    class="elevation-1"
    :items-per-page-options="footerProps.itemsPerPageOptions"
    @update:options="updateTable"
  >
    <template #top>
      <v-card-title>
        <v-toolbar flat>
          <v-toolbar-title>Test Campaigns</v-toolbar-title>

          <v-spacer />

          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            @input="searchTable()"
          />

          <v-spacer />

          <v-btn
            v-if="hasPermission('create lead::campaigns')"
            dark
            class="mb-2 btn-bg-deep-blue"
            @click="dialogForm = true"
          >
            <v-icon>mdi-plus</v-icon>
            New Campaign Testing
          </v-btn>
          <disabled-for-lack-of-role-btn
            v-else
            text="New Campaign Testing"
            permission="create lead::campaigns"
            :x-small="false"
            button-class="mb-2"
          />

          <CampaignTestingForm
            v-if="dialogForm"
            :initial-data="editedItem"
            :campaigns="campaigns"
            @close-modal="closeModal('dialogForm')"
            @item-saved="itemSaved()"
            @click:outside="clearState()"
          />
        </v-toolbar>
      </v-card-title>
    </template>

    <template #item.actions="{ item }">
      <v-icon
        v-if="hasPermission('edit lead::campaigns')"
        :id="item"
        class="mr-10"
        @click="editItem(item)"
      >
        mdi-pencil-outline
      </v-icon>
      <disabled-for-lack-of-role-btn
        v-else
        text=""
        icon="mdi-pencil-outline"
        :text-button="true"
        permission="edit lead::campaigns"
        :x-small="false"
        button-class="mr-10"
      />
    </template>
  </v-data-table-server>
</template>

<script>
import dataTableMixin from '@/mixins/dataTableMixin.js';

import CampaignTestingForm from './CampaignTestingForm.vue';
import DisabledForLackOfRoleBtn from '../../DisabledForLackOfRoleBtn.vue';

export default {
  components: {
    CampaignTestingForm,
    DisabledForLackOfRoleBtn,
  },

  mixins: [dataTableMixin],

  data: () => ({
    headers: [
      { title: 'Partner', value: 'company_name' },
      { title: 'Campaign Name', value: 'campaign_name' },
      { title: 'Campaign ID', value: 'campaign_id' },
      { title: 'Active ?', value: 'active' },
      {
        title: 'Actions',
        value: 'actions',
        sortable: false,
        align: 'start',
        width: 183,
      },
    ],

    dialogDelete: false,
    dialogForm: false,
    editedItem: {
      id: null,
    },

    campaigns: [],
  }),

  computed: {
    mappedItems() {
      return (this.items || []).map((item) => ({
        ...item,
        enabled: !!item.enabled,
        docusign_id_check: !!item.docusign_id_check,
        onfido_enabled: !!item.onfido_enabled,
        prove_enabled: !!item.prove_enabled,
        skip_landing_page: !!item.skip_landing_page,
      }));
    },
  },

  created() {
    this.getCampaigns();
  },

  methods: {
    closeModal(modal) {
      this[modal] = false;
      this.clearState();
    },
    deleteItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = { ...item };
      this.dialogDelete = true;
    },
    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = { ...item };
      this.dialogForm = true;
    },
    itemDeleted() {
      this.items = [];
      this.updateTable();
    },
    itemSaved() {
      this.items = [];
      this.updateTable();
    },
    updateTable() {
      this.loading = true;

      return this.$axios
        .get('api/v1/test-campaigns', {
          params: {
            perPage: this.options.itemsPerPage,
            page: this.options.page,
            ...this.sortParams,
            search: this.search,
          },
        })
        .then((res) => {
          this.loading = false;
          this.items = res.data.data;
          this.totalItems = res.data.total;
        });
    },
    clearState() {
      this.$nextTick(() => {
        this.editedItem = {};
        this.editedIndex = -1;
      });
    },

    getCampaigns() {
      this.$axios
        .get('api/v1/campaign', {
          params: {
            perPage: 100,
          },
        })
        .then(({ data }) => {
          this.campaigns = data.data;
        });
    },
  },
};
</script>
